__turbopack_context__.v({
  "markdown": "gYLTtq_markdown",
  "regular": "gYLTtq_regular",
});
